<header class="sub-page-layout__header diagnosisCodes__header">
  <div class="diagnosisCodes__header-text h2 h2--semi-bold">Diagnosis Codes</div>
  <mat-slide-toggle
    class="diagnosisCodes__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="diagnosisCodes__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Diagnosis Codes
  </button>
  <button
    mat-flat-button
    color="primary"
    class="diagnosisCodes__add-item"
    (click)="addDiagnosisCodes()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Diagnosis Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Diagnosis Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation && itemCount > 0" class="diagnosisCodes__footer">
  <lib-button-loading color="primary" class="diagnosisCodes__button" [invalid]="itemCount === 0" (clickEvent)="next()"
    >Next
  </lib-button-loading>
</footer>
